import { motion } from "framer-motion";

export function Reveal({ children, className = "", delay = 0, y = 28, as = "div" }) {
  const MotionTag = motion[as] || motion.div;
  return (
    <MotionTag
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-10% 0px -10% 0px" }}
      transition={{ duration: 0.9, delay, ease: [0.16, 1, 0.3, 1] }}
    >
      {children}
    </MotionTag>
  );
}

// Line-by-line masked headline reveal.
export function AnimatedHeadline({ lines, className = "", delay = 0, immediate = false }) {
  const container = {
    hidden: {},
    show: { transition: { staggerChildren: 0.09, delayChildren: delay } },
  };
  const line = {
    hidden: { y: "110%" },
    show: { y: "0%", transition: { duration: 0.95, ease: [0.16, 1, 0.3, 1] } },
  };
  return (
    <motion.h1
      className={className}
      variants={container}
      initial="hidden"
      {...(immediate
        ? { animate: "show" }
        : { whileInView: "show", viewport: { once: true, margin: "-15% 0px" } })}
    >
      {lines.map((text, i) => (
        <span key={i} className="reveal-mask">
          <motion.span variants={line} style={{ display: "block" }}>
            {text}
          </motion.span>
        </span>
      ))}
    </motion.h1>
  );
}

export default Reveal;
